import { ListCashSessionsParams } from '@/@types/cash-management';
import { listCashSessions } from '@/api/cash_management';
import { useQuery } from '@tanstack/react-query';

type UseCashSessionsParams = ListCashSessionsParams & {
  enabled?: boolean;
};

export function useCashSessions({
  page = 0,
  perPage = 0,
  enabled = true,
  ...params
}: UseCashSessionsParams) {
  return useQuery({
    queryKey: ['cash-sessions', { page, perPage, ...params }],
    queryFn: () => listCashSessions({ page, perPage, ...params }),
    staleTime: 1000 * 60 * 1,
    enabled,
  });
}
